<template>

  <div class="card z-depth-0">
    <!-- Top -->
    <div class="card-content z-depth-1 blue-grey lighten-5" v-if="cluster.status !== 'q' && cluster?.scheme_id != 1">
      <div class="row">
        <div class="col s6 teal lighten-4" @click.prevent="handleDownloadClaims()">
          <h5 title="Download"><a href="#"><i class="blue-text medium material-icons clickable">attach_file</i> Claims
              <small><u>Spreedsheet</u></small></a></h5>
        </div>
        <div class="col s6 indigo lighten-4" @click.prevent="handleDownloadEncounters()">
          <h5 title="Download"><a href="#"><i class="blue-text medium material-icons clickable">attachment</i>
              Encounters <small><u>Spreedsheet</u></small></a></h5>
        </div>
      </div>
    </div>

    <!-- Main -->
    <nav class="white z-depth-0 hide-on-small-only">
      <div class="nav-wrapper z-depth-0">
        <form method="POST" action="#">
          <div class="input-field blue-text text-darken-2">
            <input type="search" v-model="searchItem" @focus="handleClearSearch()"
              placeholder="Search by Enrollee Name, or by Enrollee ID" />
            <label class="label-icon" for="search"><i class="material-icons black-text">search</i></label>
            <i class="material-icons white-text orange" @click="handleClearSearch()" v-if="searchItem">clear</i>
          </div>
        </form>
      </div>
    </nav>

    <!-- Mobile -->
    <nav class="white hide-on-med-and-up">
      <div class="nav-wrapper">
        <form method="POST" action="#">
          <div class="input-field blue-text text-darken-2 z-depth-0">
            <input type="search" v-model="searchItem" @focus="handleClearSearch()"
              placeholder="Search by Enrollee Name, or by Enrollee ID" />
            <label class="label-icon" for="search">
              <i class="material-icons white-text orange pointable" @click="handleClearSearch()"
                v-if="searchItem">clear</i>
              <i class="material-icons black-text" v-else>search</i>
            </label>
            <i class="material-icons black-text" title="Send" @click="handleSearchMobi()" v-if="searchItem">send</i>
          </div>
        </form>
      </div>
    </nav>

    <div class="progress" v-if="isLoading">
      <div class="indeterminate"></div>
    </div>

    <!-- main  -->
    <div class="card z-depth-1">
      <div class="card-content white">
        <table class="highlight responsive-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name<br /><small>(Enrollee ID)</small></th>
              <th>Diagnosis</th>
              <th>Sent</th>
              <th class="teal-text" v-if="cluster.status === 'v' && !lock">Approved</th>
              <th>Encounter</th>
              <th></th>
            </tr>
          </thead>
          <tbody>

            <!-- Encounters -->
            <tr class="clickable" v-for="(encounter, index) in bills" :key="encounter.id"
              @click.prevent="handleStart(encounter)">
              <td>{{ index + 1 }}</td>
              <td>
                {{ encounter.name }}<br />
                ({{ encounter.enrollee_number }})
              </td>
              <td>{{ encounter.diagnosis }}</td>
              <td>
                ₦{{ totalSent(encounter) }}
              </td>
              <td v-if="cluster.status === 'v' && !lock">
                ₦{{ totalApproved(encounter) }}
              </td>
              <td>
                {{
                  new Date(encounter.encounter_date).toLocaleString(
                    undefined,
                    {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    }
                  )
                }}
              </td>
              <td>
                <i class="material-icons pointable" :class="{
                  'yellow-text text-darken-2': encounter.status === 'q',
                }" :title="`${encounter.status === 'q' ? 'pending' : 'done'}`">{{
                  encounter.status === "q" ? "watch_later" : "check_circle"
                }}
                </i>
              </td>
            </tr>

            <!-- Total -->
            <tr v-if="encounters.length">
              <td colspan="2"></td>
              <td>Totals:</td>
              <td class="red-text text-darken-2"><b>₦{{ grandTotalSent(encounters) }}</b></td>
              <td class="green-text text-darken-2" v-if="cluster.status === 'v' && !lock"><b>₦{{
                grandTotalApproved(encounters) }}</b></td>
              <td colspan="2"></td>
            </tr>

            <!-- No encounters yet -->
            <tr v-else>
              <td colspan="6" class="center">No Claims Added Yet!</td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Loader -->
  <div class="progress" v-if="isSubmitting">
    <div class="indeterminate"></div>
  </div>

</template>

<script>
import { computed, onMounted, ref, watchEffect, watch } from "vue";
import {
  totalSentInputFx,
  grossTotalSentInputFx,
  totalApprovedFx,
  grossTotalApprovedFx,
} from "@/composables/calFunction/cal";
import {
  downloadExcelFx,
} from "@/composables/reportFunction/downloader";


export default {
  name: "SummaryClaimComponent",
  props: ["cluster", "encounters", "isSubmitting", "isManual"],
  emits: ["cancel", "reload", "restart"],
  setup(props, context) {
    const lock = ref(true);
    const isLoading = ref(false);
    const response = ref(null);
    const searchItem = ref(null);
    const search = ref(false);

    // retrieve
    onMounted(() => {
      // start
      response.value = props.encounters;
    });

    // watch for changes
    watch(props, (newVal) => {
      response.value = newVal.encounters;
    });

    // total calculations
    const totalSent = (encounter) => {
      return totalSentInputFx(encounter);
    }

    // total calculations
    const grandTotalSent = (encounter) => {
      return grossTotalSentInputFx(encounter);
    }

    // total approved
    const totalApproved = (encounter) => {
      return totalApprovedFx(encounter);
    }

    // grand total approved
    const grandTotalApproved = (encounter) => {
      return grossTotalApprovedFx(encounter);
    }

    // switch page
    const handleStart = (encounter) => {
      // reload
      context.emit("reload", {
        encounter: encounter,
      });
    };

    // restart (clear)
    const handleRestart = () => {
      context.emit("restart", true);
    }

    // default
    const sortDefault = () => {
      if (response.value) {
        // start
        searchItem.value = null;
        // Sort cby pending
        response.value = props.encounters;
      }
    }

    // searcher
    const sortSearch = () => {
      if (response.value) {
        // sort
        response.value.sort((a, b) => {
          const searchValue = searchItem.value.toLowerCase();
          const matchesA = a.name.toLowerCase().includes(searchValue) ||
            a.enrollee_number.toLowerCase().includes(searchValue);
          const matchesB = b.name.toLowerCase().includes(searchValue) ||
            b.enrollee_number.toLowerCase().includes(searchValue);

          if (matchesA && !matchesB) {
            return -1; // a comes first
          } else if (!matchesA && matchesB) {
            return 1;  // b comes first
          } else {
            return 0;  // no change in order
          }

        });

        // start loading
        isLoading.value = true;
        // end loading
        setTimeout(() => {
         isLoading.value = false;
        }, 2000);

      }
    }

    // restart
    const handleClearSearch = () => {
      //searchItem.value = null;
      sortDefault();
    };

    // search mobi
    const handleSearchMobi = () => {
      if (searchItem.value) {
        // search
        sortSearch();
      }
    }

    // search watcher
    watchEffect(() => {
      if (searchItem.value) {
        // search
        sortSearch();
      } else {
        sortDefault();
      }
    });

    // cancel
    const handleCancel = () => {
      context.emit("cancel", true);
    }

    // output results
    const bills = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value;
      }
    });

    // download claims
    const handleDownloadClaims = () => {
      let data = [];
      let filteredClaims = [];


      // total
      props.encounters.forEach((x, y) => {
        // clear
        filteredClaims = [];
        // filter 
        filteredClaims = x.claims.filter(claim => !(claim.sent_price == "0.00" && claim.approved_price == "0.00"));

        // counter
        if (filteredClaims.length) {

          // detail
          x.claims.forEach((z, j) => {

            if (j === 0) {

              // first
              data.push({
                No: y + 1,
                Name: x.name,
                ID: x.enrollee_number,
                Encounter: x.encounter_date,
                End: x.encounter_date_end,
                Diagnosis: x.diagnosis,
                Item: z.item,
                Sent_Qty: z.sent_qty,
                Sent: z.sent_price,
                Authorization: z.authorization == 'y' ? z.authorization_code : '',
              })

            } else {

              // others
              data.push({
                No: "",
                Name: "",
                ID: "",
                Encounter: "",
                End: "",
                Diagnosis: "",
                Item: z.item,
                Sent_Qty: z.sent_qty,
                Sent: z.sent_price,
                Authorization: z.authorization == 'y' ? z.authorization_code : '',
              })

            }

          })

        }

        // total
        data.push({
          No: "",
          Name: "",
          ID: "",
          Encounter: "",
          End: "",
          Diagnosis: "",
          Item: "",
          Sent_Qty: "Subtotal",
          Sent: totalSent(x),
          Authorization: "",
        })

        // space
        data.push({})

      });

      // space
      data.push({})

      // final
      data.push({
        No: "",
        Name: "",
        ID: "",
        Encounter: "",
        End: "",
        Diagnosis: "",
        Item: "",
        Sent_Qty: "Grand Total",
        Sent: grandTotalSent(props.encounters),
        Authorization: "",
      })

      // fire function
      return downloadExcelFx(data, `${props.cluster.provider.name}_${props.cluster.scheme.name}_${props.cluster.month.name}_${props.cluster.year.name}_Claims`);
    }

    // download encounters
    const handleDownloadEncounters = () => {
      let data = [];

      // total
      props.encounters.forEach((x, y) => {

        // detail
        x.claims.forEach((z, j) => {

          if (j === 0) {

            // first
            data.push({
              No: y + 1,
              Name: x.name,
              ID: x.enrollee_number,
              Age: x?.stores?.age ? x?.stores?.age : "",
              Sex: x.sex == "m" ? "Male" : "Female",
              Type: x.type == "p" ? "Principal" : "Dependant",
              Encounter: x.encounter_date,
              End: x.encounter_date_end,
              Referral: x.provider_id != x.picked_provider_id ? "Referred" : "Nil" ,
              Hospitalization: x.encounter_date != x.encounter_date_end ? "Admission" : "Outpatient",
              Diagnosis: x.diagnosis,
              Item: z.item,
              Sent_Qty: z.sent_qty,
              Doctor: x?.stores?.doctor ? x?.stores?.doctor : "",
            })

          } else {

            // others
            data.push({
              No: "",
              Name: "",
              ID: "",
              Age: "",
              Sex: "",
              Type: "",
              Encounter: "",
              End: "",
              Referral: "",
              Hospitalization: "",
              Diagnosis: "",
              Item: z.item,
              Sent_Qty: z.sent_qty,
              Doctor: "",
            })

          }

        })

        // total
        data.push({
          No: "",
          Name: "",
          ID: "",
          Age: "",
          Sex: "",
          Type: "",
          Encounter: "",
          End: "",
          Referral: "",
          Hospitalization: "",
          Diagnosis: "",
          Item: "",
          Sent_Qty: "",
          Doctor: "",
        })

        // space
        data.push({})

      });

      // space
      data.push({})

      // final
      data.push({
        No: "",
        Name: "",
        ID: "",
        Age: "",
        Sex: "",
        Type: "",
        Encounter: "",
        End: "",
        Referral: "",
        Hospitalization: "",
        Diagnosis: "",
        Item: "",
        Sent_Qty: "",
        Doctor: "",
      })

      // fire function
      return downloadExcelFx(data, `${props.cluster.provider.name}_${props.cluster.scheme.name}_${props.cluster.month.name}_${props.cluster.year.name}_Encounters`);
    }

    return {
      lock,
      handleSearchMobi,
      handleClearSearch,
      handleDownloadClaims,
      handleDownloadEncounters,
      handleCancel,
      handleRestart,
      handleStart,
      search,
      searchItem,
      isLoading,
      grandTotalSent,
      totalSent,
      totalApproved,
      grandTotalApproved,
      bills,
    };
  },
};
</script>

<style scoped>
.progress {
  margin-top: -2px;
}

.custom-hr {
  width: 50%;
  /* Adjust the width as needed */
  border: none;
  border-top: 2px solid #ccc;
  /* Adjust the color and style as needed */
  margin: 20px 20px;
  /* Adjust margin as needed */
}

.styled-text {
  background-color: #fafad2;
  /* Light Golden Yellow */
  /* border: 2px solid #000; Black border */
  padding: 2px;
  /* Adequate padding */
}

.capsule {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 20px;
  background-color: #f0f0f0;
  /* Adjust the background color as needed */
}

.clickable {
  cursor: pointer;
}

.pointable {
  cursor: default;
  opacity: 1;
  /* Default opacity */
  transition: opacity 0.3s ease;
  /* Smooth opacity change */
}

.pointable:hover {
  opacity: 0.8;
  /* Slightly reduced opacity on hover */
}
</style>